(function($) {

var myLazyLoad;


// Animsition
// -----------------------------------------------------------------------------

	$(document).ready(function() {
		$(".animsition").animsition({
			inClass: 'fade-in',
			outClass: 'fade-out',
			inDuration: 1500,
			outDuration: 750,
			linkElement: '.animsition-link',
			loading: true,
			loadingParentElement: 'body', //animsition wrapper element
			loadingClass: 'animsition-loading',
			loadingInner: '', // e.g '<img src="loading.svg" />'
			timeout: true,
			timeoutCountdown: 2000,
			onLoadEvent: true,
			browser: [ 'animation-duration', '-webkit-animation-duration'],
			overlay : false,
			overlayClass : 'animsition-overlay-slide',
			overlayParentElement : 'body',
			transition: function(url){ window.location.href = url; }
		});

		$('.animsition').on('animsition.outStart', function(){
			$(".dropdown-menu").removeClass("dropdownOpen");
			$(".dropdown-menu, .filter__content").addClass("dropdownFade");
			$(".storefront-primary-navigation, .mobile-menu-overlay").removeClass("menuOpen");
		});

		$('.animsition').on('animsition.inStart', function(){
			$(".private-room-image").addClass("private-room-image--visible");
		});

		$(window).on('load resize', function(){

			if($(window).width() > 1000){
				$(document).on("click", ".primary-navigation li#menu-item-620 a", function(event){
					event.preventDefault();
					var $elem = $(this);
					var url = $elem.attr('href');
					$(".animsition").animsition('out', $elem, url);
				});
				$( "#menu-item-620, .js-jewels-dropdown" ).hover(
					function() {
						$(".js-jewels-dropdown").addClass("dropdownOpen");
					}, function() {
						$(".js-jewels-dropdown").removeClass("dropdownOpen");
					}
				);
				$(document).on("click", ".primary-navigation li#menu-item-5306 a", function(event){
					event.preventDefault();
					var $elem = $(this);
					var url = $elem.attr('href');
					$(".animsition").animsition('out', $elem, url);
				});
				$( "#menu-item-5306, .js-objects-dropdown" ).hover(
					function() {
						$(".js-objects-dropdown").addClass("dropdownOpen");
					}, function() {
						$(".js-objects-dropdown").removeClass("dropdownOpen");
					}
				);
				$(document).on("click", ".primary-navigation li#menu-item-7938 a", function(event){
					event.preventDefault();
					var $elem = $(this);
					var url = $elem.attr('href');
					$(".animsition").animsition('out', $elem, url);
				});
				$( "#menu-item-7938, .js-bridal-dropdown" ).hover(
					function() {
						$(".js-bridal-dropdown").addClass("dropdownOpen");
					}, function() {
						$(".js-bridal-dropdown").removeClass("dropdownOpen");
					}
				);
			}else{
				$(".primary-navigation li#menu-item-620 a").unbind().click(function(){
					event.preventDefault();
					$(".js-jewels-dropdown").toggleClass("dropdownOpen");
				});
				$(".primary-navigation li#menu-item-5306 a").unbind().click(function(){
					event.preventDefault();
					$(".js-objects-dropdown").toggleClass("dropdownOpen");
				});
				$(".primary-navigation li#menu-item-7938 a").unbind().click(function(){
					event.preventDefault();
					$(".js-bridal-dropdown").toggleClass("dropdownOpen");
				});
			};
		});

		$(document).on("click", ".primary-navigation li:not(#menu-item-620, #menu-item-5306, #menu-item-7938) a", function(event){
			event.preventDefault();
			var $elem = $(this);
			var url = $elem.attr('href');
			$(".animsition").animsition('out', $elem, url);
		});

		$(document).on("click", "#menu-footer-menu a", function(event){
			event.preventDefault();
			var $elem = $(this);
			var url = $elem.attr('href');
			$(".animsition").animsition('out', $elem, url);
		});

		$(document).on("click", ".woocommerce-breadcrumb a", function(event){
			event.preventDefault();
			var $elem = $(this);
			var url = $elem.attr('href');
			$(".animsition").animsition('out', $elem, url);
		});

		$(document).on("click", "body.page-id-621", function(event){
			event.preventDefault();
			var $elem = $(this);
			var url = $elem.attr('href');
			$(".animsition").animsition('out', $elem, '/home');
		});

	});





// Slick Related
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		$('.related__section__slideshow--slick').each(function() {
			$(this).slick({
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 4,
				slidesToScroll: 4,
				centerMode: false,
				appendDots: $(this).parents(".row").find(".dots-wrapper"),
				responsive: [
				    {
				      breakpoint: 1000,
				      settings: {
				        arrows: false,
				      }
				    },
				    {
				      breakpoint: 800,
				      settings: {
				        slidesToShow: 3,
				        slidesToScroll: 3,
				        arrows: false,
				      }
				    },
				    	{
				      breakpoint: 600,
				      settings: {
				        slidesToShow: 2,
				        slidesToScroll: 2,
				        arrows: false,
				      }
				    },
				]
			}).on('afterChange', function(event, slick, currentSlide, nextSlide){
				myLazyLoad.update();
			});
		});
		$('.curated__section__slideshow--slick').each(function() {
			$(this).slick({
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 3,
				centerMode: false,
				appendDots: $(this).parents(".row").find(".dots-wrapper"),
				responsive: [
				    {
				      breakpoint: 1000,
				      settings: {
				        arrows: false,
				      }
				    },
				    	{
				      breakpoint: 600,
				      settings: {
				        slidesToShow: 2,
				        slidesToScroll: 2,
				        arrows: false,
				      }
				    },
				]
			});
		}).on('afterChange', function(event, slick, currentSlide, nextSlide){
			myLazyLoad.update();
		});
	});


// Lazy Load
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		myLazyLoad = new LazyLoad({
			elements_selector: ".lazy",
		});
	});


// Cookies
// -----------------------------------------------------------------------------

	$(document).ready(function() {
		$.cookieBar({fixed: true});
	});


// Detect Mobile
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		if(isMobile == true){
			$("html").removeClass("desktop-device");
			$("html").addClass("touch-device");
		}else{};
	});





// Newsletter Toggle
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		$('.newsletterToggle').click(function(){
			if($(".site-footer").hasClass("newsletterActive")){
				if($(".site-footer").hasClass("newsletterActive--small")){
					$(".footer-buster").css("height", "");
					$(".site-footer").css("bottom", "");
					$(".site-footer").toggleClass("newsletterActive newsletterActive--small");
					$("html, body").animate({ scrollTop: $(document).height() }, 750);
				}else{
					$(".footer-buster, .site-footer").toggleClass("newsletterActive");
					$("html, body").animate({ scrollTop: $(document).height() }, 750);
				}
			}else{
				if(($(".site-footer").height() + 80) > $(window).height()){
					var mainFooterHeight = $(".main-footer").outerHeight() + $(".sub-footer").outerHeight();
					var newsletterHeight = $(".newsletter-form.in-footer").outerHeight();
					$(".footer-buster").outerHeight(newsletterHeight);
					$(".site-footer").css("bottom", -(mainFooterHeight));
					$(".site-footer").toggleClass("newsletterActive newsletterActive--small");
					$("html, body").animate({ scrollTop: $(document).height() }, 750);
				}else{
					$(".footer-buster, .site-footer").toggleClass("newsletterActive");
					$("html, body").animate({ scrollTop: $(document).height() }, 750);
				}
			}
		});
	});




// :: Request Access Toggle
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		$('.request-access-toggle').click(function(e){
			e.preventDefault();
			$(".request-access-form").slideToggle();
		});
	});




// :: In Confidence Designer Scroll
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		$('.in-confidence-designer__scroll').click(function(e){
			e.preventDefault();
			$([document.documentElement, document.body]).animate({
				scrollTop: $(".in-confidence-designer__content").offset().top
			}, 2000);
		});
	});



// :: Image Offset (Story & Designer)
// -----------------------------------------------------------------------------

	$(window).on('load resize', function() {
		if($(".offset-image img").length){
			$(".add-margin").css("margin-bottom", "");
			var imgOffset = $(".offset-image img").offset();
			var imgHeight = $(".offset-image img").height();
			var imgBottom = imgOffset.top + imgHeight;
			var sectionOffset = $(".add-margin").offset();
			var sectionHeight = $(".add-margin").height();
			var sectionBottom = sectionOffset.top + sectionHeight;
			var marginBottom = imgBottom - sectionBottom;
			if(marginBottom > 0){
				$(".add-margin").css("margin-bottom", marginBottom);
			};
		};
	});





// :: Truncate Text
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		var windowWidth = $(window).width();

			if($(".woocommerce-product-details__short-description").length && $(".woocommerce-product-details__short-description").children().length > 2){
				$(".woocommerce-product-details__short-description").children("p").not(':nth-of-type(1)').wrapAll('<div class="truncated-text" />');
				$(".truncated-text").after('<p class="margin-top--med"><a class="underlined-links truncateToggle truncateMore" href="javascript:void(0);">Read more</a></p>');
			};

		$(document).on('click', '.truncateToggle', function(){
			$(".truncated-text").slideToggle();
			if($(this).hasClass("truncateMore")){
				$(this).removeClass("truncateMore");
				$(this).addClass("truncateLess");
				$(this).html("Read less");
			}else{
				$(this).removeClass("truncateLess");
				$(this).addClass("truncateMore");
				$(this).html("Read more");
			}
		});
	});





// :: Menu Toggle
// -----------------------------------------------------------------------------

	function menuToggle() {
		if ($(".storefront-primary-navigation").hasClass("menuOpen")) {
			$(".storefront-primary-navigation, .mobile-menu-overlay").removeClass("menuOpen");
			bodyScrollLock.clearAllBodyScrollLocks();
		} else {
			$(".storefront-primary-navigation, .mobile-menu-overlay").addClass("menuOpen");
			var targetElement = document.querySelector(".dropdown-menu");
			bodyScrollLock.disableBodyScroll(targetElement);
		}
	}

	$(document).ready(function(){
		$(".menuToggle").click(function(){
			menuToggle();
			$(".dropdown-menu").removeClass("dropdownOpen");
		});
	});


	$(document).ready(function(){
		$(".filter-toggle a").click(function(){
			$(".dropdown-menu").toggleClass("dropdownOpen");
			$(".mobile-menu-overlay").toggleClass("menuOpen");
		});
	});

	$(document).ready(function(){
		$(".mobile-menu-overlay").click(function(){
			$(".dropdown-menu").removeClass("dropdownOpen");
			$(".sub-menu-nav").removeClass("filterOpen");
			$(".storefront-primary-navigation, .mobile-menu-overlay").removeClass("menuOpen");
			bodyScrollLock.clearAllBodyScrollLocks();
		});
		$(".dropdownToggle").click(function(){
			$(".dropdown-menu").removeClass("dropdownOpen");
			if(!$(".storefront-primary-navigation").hasClass("menuOpen")){
				$(".mobile-menu-overlay").removeClass("menuOpen");
			}
		});
	});





// :: Fade Scroll
// -----------------------------------------------------------------------------

	$(window).on('load scroll', function(){
		$(".scrollFade").each(function() {
			if (isScrolledIntoView($(this))) {
				$(this).addClass("inView");
			}else{};
		});
	});

	function isScrolledIntoView(elem) {
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();

		var elemTop = $(elem).offset().top;
		var elemBottom = elemTop + $(elem).height();

		return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
	};





// :: Reveal Footer Lower
// -----------------------------------------------------------------------------

	$(window).on('load scroll resize', function(){
		var footerOffset = $(".footer-buster").offset().top;
		var docViewBottom = $(window).scrollTop() + $(window).height();
		if(footerOffset - 200 < docViewBottom){
			$(".site-footer").addClass("footer-visible");
		}else{
			$(".site-footer").removeClass("footer-visible");
		}
	});





// :: Match Width of All Dropdowns
// -----------------------------------------------------------------------------

	$(window).on('load resize', function(){
		$(".sub-menu .filter__content").css("width", "");
		var maxWidth = Math.max.apply(null, $('.sub-menu .filter__content').map(function (){
			return $(this).outerWidth(true);
		}).get() );
		$(".sub-menu .filter__content").css("width", maxWidth + "px");
	});



// :: Variable Products Price
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		$( ".variations_form" ).on( "woocommerce_variation_select_change", function () {
			$(".float-wrapper > .price").show();

		});
		$( ".variations_form" ).on( "show_variation", function (event, variation) {
			if($(".woocommerce-variation.single_variation").is(":visible") && $(".single_variation .price").length){
				$(".float-wrapper > .price").hide();
			}else{
				$(".float-wrapper > .price").show();
			};
		});
	});





// :: Catalog Filtering
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		$("#catalog-filter-submit").click(function(e){
			e.preventDefault();
			e.stopPropagation();
			var checked = document.querySelectorAll('input[type=checkbox]:checked');
			var category = [];
			var material = [];
			var designer = [];
			var colour = [];
			var submitLink = window.location.href.split('?')[0] + "?";

			for(var i = 0; i < checked.length; i++) {
				if($(checked[i]).data("filter") == "category"){
					category.push(checked[i].value);
				}
				if($(checked[i]).data("filter") == "material"){
					material.push(checked[i].value);
				}
				if($(checked[i]).data("filter") == "designer"){
					designer.push(checked[i].value);
				}
				if($(checked[i]).data("filter") == "colour"){
					colour.push(checked[i].value);
				}
			}

			if(category.length){(submitLink += "&category=" + category.join(","))};
			if(material.length){(submitLink += "&material=" + material.join(","))};
			if(designer.length){(submitLink += "&designers=" + designer.join(","))};
			if(colour.length){(submitLink += "&colour=" + colour.join(","))};

			window.location = submitLink;
		});
		$("#catalog-filter-clear").click(function(e){
			e.preventDefault();
			e.stopPropagation();
			window.location = window.location.href.split('?')[0];
		});
	});

	$(document).ready(function(){
		$(".filter-toggle").click(function(){
			$(".filter-panel").toggleClass("filterOpen");
			$(".filter-overlay").toggleClass("menuOpen");
			var targetElement = $(".filter-panel__wrapper").get(0);
			bodyScrollLock.disableBodyScroll(targetElement, {
				reserveScrollBarGap: true,
			});
		});
		$(".filter-overlay, .filter-cross").click(function(){
			$(".filter-panel").removeClass("filterOpen");
			$(".filter-overlay").removeClass("menuOpen");
			bodyScrollLock.clearAllBodyScrollLocks();
		});
	});





// :: In Confidence Slideshow
// -----------------------------------------------------------------------------

	$(document).ready(function(){

		// Canvas Image

		var containers = $(".in-confidence_image");
		var count = 0;
		var easeTime = 500;
		var renderers = {};
		var timelines = {};
		var previousSlide = 0;
		var renderer,
			raf,
			tl,
			i;

		for (i = 0; i < containers.length; i++) {
			var container = containers[i];
			var width = container.offsetWidth;
			var height = container.offsetHeight;
			var renderer = new PIXI.Application(width, height, { transparent: true });
				container.appendChild(renderer.view);

			var imageFullData = container.dataset.full;
			var imageDuotoneData = container.dataset.duotone;
			var imageSlug = container.dataset.slug;

			var imageFull = new PIXI.Sprite.fromImage(imageFullData);
			var imageDuotone = new PIXI.Sprite.fromImage(imageDuotoneData);

			imageFull.anchor.set(0.5);
			imageDuotone.anchor.set(0.5);
			imageFull.x = imageDuotone.x = width / 2;
			imageFull.y = imageDuotone.y = height / 2;
			//imageFull.width = imageDuotone.width = width / 1.1;
			//imageFull.height = imageDuotone.height = height / 1.1;
			imageFull.width = imageDuotone.width = width / 1;
			imageFull.height = imageDuotone.height = height / 1;

			//renderer.stage.interactive = true;
			//renderer.stage.buttonMode = true;

			var displacementSprite = PIXI.Sprite.fromImage('/wp-content/themes/storefront-child/dist/img/cloud.png');
				displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
			var displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);

			displacementSprite.scale.set(1.5);
			displacementFilter.scale.set(0);

			renderer.stage.addChild(displacementSprite);
			renderer.stage.addChild(imageFull);
			renderer.stage.addChild(imageDuotone);
			renderer.stage.filters = [displacementFilter];

			renderers[imageSlug] = renderer;
		};


		$(".in-confidence_slideshow").on('init', function(){
			var currentSlideSlug = $(".slick-current").data("slug");
			displacementFirst(renderers[currentSlideSlug].stage, currentSlideSlug);
		});

		$(".in-confidence_slideshow").on('beforeChange', function(event, slick, currentSlide, nextSlide){
			var nextSlideSlug = $("[data-slick-index=" + nextSlide + "]").data("slug");
			var currentSlideSlug = $("[data-slick-index=" + currentSlide + "]").data("slug");
			previousSlide = currentSlide;
			displacementOn(renderers[nextSlideSlug].stage, nextSlideSlug);
			displacementOff(renderers[currentSlideSlug].stage, currentSlideSlug);
		});

		$(".in-confidence_slideshow").on('afterChange', function(event, slick, currentSlide){
			if(previousSlide == currentSlide){
				var currentSlideSlug = $("[data-slick-index=" + currentSlide + "]").data("slug");
				timelines[currentSlideSlug].reverse();
				//displacementOn(renderers[currentSlideSlug].stage, currentSlideSlug);
			}

			//previousSlide = currentSlide;
			//displacementOn(renderers[nextSlideSlug].stage, nextSlideSlug);

		});

		//

		function displacementFirst(stage, slug){
			stage.filters[0].scale.set(0);
			stage.children[0].x = 0;
			stage.children[0].y = 0;
			stage.children[2].alpha = 0;
			timelines[slug] = new TimelineMax({paused: true});
		}
		function displacementOn(stage, slug){
			if(timelines[slug]){
				timelines[slug].stop();
			}
			stage.filters[0].scale.set(0);
			stage.children[0].x = 0;
			stage.children[0].y = 0;
			stage.children[2].alpha = 1;
			//cancelAnimationFrame(raf);
			timelines[slug] = new TimelineMax({paused: true});
			timelines[slug].to(stage.filters[0].scale, (0.5), { x: 100, y: 100})
			  .to(stage.children[0], (4), { x: 400, y: 400}, 0)
			  .to(stage.children[2], (2), {alpha:0}, 0)
			  .to(stage.filters[0].scale, (1.6), { x: 0, y: 0, delay: (0.8)}, 0);
			timelines[slug].play();
			//displacementAnimation(stage.children[0]);
		}
		function displacementOff(stage, slug){
			timelines[slug].stop();
			stage.filters[0].scale.set(0);
			stage.children[0].x = 0;
			stage.children[0].y = 0;
			stage.children[2].alpha = 0;
			//timelines[slug].reverse();
			timelines[slug] = new TimelineMax({paused: true});
			timelines[slug].to(stage.filters[0].scale, (0.5), { x: 100, y: 100})
			  .to(stage.children[0], (4), { x: 300, y: 300}, 0)
			  .to(stage.children[2], (2), {alpha:1}, 0)
			  .to(stage.filters[0].scale, (1.6), { x: 0, y: 0, delay: (0.8)}, 0);
			timelines[slug].play();
		}

		function displacementAnimation(displacementElement) {
			displacementElement.x = count*10;
			displacementElement.y = count*10;
			count += 0.3;
			raf = window.requestAnimationFrame(function() {
				displacementAnimation(displacementElement);
			});
		};

		$(".in-confidence_slideshow").slick({
			infinite: false,
			speed: 1000,
			slidesToShow: 1,
			centerMode: true,
			variableWidth: true,
			touchThreshold: 75
		});

	});




// :: In Confidence Masonry
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		if($("body").hasClass("tax-product_cat") && $("body").hasClass("in-confidence") && !$("body").hasClass("term-79")){
			var introTop = $(".in-confidence-designer__intro").offset().top;
			var introHeigt = $(".in-confidence-designer__intro").outerHeight();
			var introMargin = (introTop + introHeigt) / 4;
			$(".in-confidence-designer__campaign").css("margin-top", introMargin);
			var productImages = $('.in-confidence-designer__content-wrapper').masonry({
				columnWidth: '.grid-sizer',
				gutter: 0,
				percentPosition: true,
				itemSelector: '.product',
			});


			function calculateMargins(){
				var productHeight = $(".in-confidence-designer__content-wrapper").height();
				var campaignHeight = 0;
				var campaignImages = $(".in-confidence-designer__campaign-wrapper .img-wrapper");
				var campaignImagesLength = campaignImages.length;
				campaignImages.each(function(){
					campaignHeight = campaignHeight + $(this).outerHeight(true);
				});

				var remainingSpace = (productHeight - campaignHeight - introMargin) / (campaignImagesLength);
				var campaignImages = campaignImages.css("margin-bottom", remainingSpace);

				var windowHeight = $(window).height();
				var pageHeight = $("#page").outerHeight() + $(".footer-buster").outerHeight();
				var speed = 6;
				var blockTop = $(".in-confidence-designer__campaign-wrapper .img-wrapper:last-of-type").offset().top;
					blockTop = blockTop - pageHeight + windowHeight;
				var blockHeight = $(".in-confidence-designer__campaign-wrapper .img-wrapper:last-of-type").outerHeight();
				var screenY = pageHeight - windowHeight;

				var basePercentage = (0 - blockTop + windowHeight) / (blockHeight + windowHeight);
				var baseParallax = speed * (100 * (1 - basePercentage));

				var endPercentage = (screenY - blockTop + windowHeight) / (blockHeight + windowHeight);
				var endParallax = speed * (100 * (1 - endPercentage));

				var compensateParallax = endParallax - baseParallax;
				var counter = 1;
				campaignImages.each(function(){
					$(this).css("margin-top", -(compensateParallax / (campaignImagesLength)));
					counter++;
				});


			}
			calculateMargins();




			var backgroundImages = $('.in-confidence-designer__campaign-wrapper').masonry({
				columnWidth: '.grid-sizer',
				percentPosition: true,
				itemSelector: '.img-wrapper',
				gutter: 0
			});

			var rellax = new Rellax('.rellax', {});

			productImages.on( 'layoutComplete', function(){
				myLazyLoad.update();
			});

			backgroundImages.on( 'layoutComplete', function(){
				myLazyLoad.update();
			});
			$(window).resize(function(){
				calculateMargins();
				backgroundImages.masonry('reloadItems');
				rellax.refresh();
			})
		};

	});





// :: Objects Masonry
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		// if(($("body").hasClass("post-type-archive-product") || $("body").hasClass("tax-product_cat") || $("body").hasClass("single-story")) && !$("body").hasClass("in-confidence")){
		// 	var productImages = $('.products').masonry({
		// 		columnWidth: '.object-sizer',
		// 		gutter: ".object-gutter",
		// 		percentPosition: true,
		// 		itemSelector: '.product',
		// 		horizontalOrder: true,
		// 		transitionDuration: 0
		// 	});
		// };
	});





// :: Pop-up Toggle
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		$(".popup-toggle, .popup-background").click(function(event){
			event.preventDefault();

			if($("html").hasClass("popup-is-active")){
				$("html").removeClass("popup-is-active");
				setTimeout(function(){
					$("html").removeClass("overflow-hidden");
					$("body").css("margin-right", "");
				}, 500)
			}else{
				$("body").css("margin-right", (window.outerWidth - document.body.scrollWidth) + "px");
				$("html").addClass("popup-is-active");
				$("html").addClass("overflow-hidden");
				if($("body").hasClass("single-product")){
					$("#nf-field-16").val("Inquiry from " + window.location.href);
				}
			};
		}).children().click(function(e) {
			return false;
		});
	});





// :: Search Toggle
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		$(".js-search-toggle").click(function(event){
			event.preventDefault();
			$("html").toggleClass("search-is-open");
			$(".dgwt-wcas-search-wrapp").slideToggle();
			if ($("html").hasClass("search-is-open")) {
				$("#dgwt-wcas-search-input-1").focus();
			} else {
				$("#dgwt-wcas-search-input-1").blur();
			}

		});
	});





// Dropdowns
// -----------------------------------------------------------------------------

	$(document).ready(function(){
		$(".variations select").selectric({
			expandToItemText: false,
			optionsItemBuilder: function(itemData, element, index) {
				if (element.attr("id").startsWith("pa_")) {
					if(itemData.element.data("href")){
						return element.val().length ? '<a href="' + itemData.element.data("href") +  '">' + itemData.text + '</a>' : itemData.text;
					}else{
						return element.val().length ? '<span data-attr="' + itemData.value +  '">' + itemData.text + '</span>' : itemData.text;
					}
				}else{
					return element.val().length ? '<span data-attr="' + itemData.value +  '">' + itemData.text + '</span>' : itemData.text;
				}
    		}
		});
	});



// :: Splash Page
// -----------------------------------------------------------------------------

	function canvasImageSize() {
		var imageRatio = $(".effect-image").data("ratio");
		var imageHeight = $(".featured-image-wrapper").outerHeight();
		var imageWidth = imageHeight / imageRatio;
		$(".effect-image").width(imageWidth);

	}

	$(window).on('load resize', function(){
		canvasImageSize();

	});

	$(document).ready(function(){

		// Cursor Navigation

		canvasImageSize();
		var $wrapper = $(".effect-wrapper");
		var $siteContent = $(".site-content");
		var $wrapperWidth = $wrapper.outerWidth();
		var $wrapperHeight = $wrapper.outerHeight();

		// Canvas Images

		var containers = $(".effect-image");
		var count = 0;
		var easeTime = 500;
		var	renderer,
			raf,
			tl,
			i;

			for (i = 0; i < containers.length; i++) {
				var container = containers[i];
				var width = container.offsetWidth;
				var height = container.offsetHeight;
				var renderer = new PIXI.Application(width, height, { transparent: true });
				container.appendChild(renderer.view);

				var imageFullData = container.dataset.full;
				var imageFull = new PIXI.Sprite.fromImage(imageFullData);

				imageFull.anchor.set(0.5);
				imageFull.x = width / 2;
				imageFull.y = height / 2;
				imageFull.width = width * 1.05;
				imageFull.height = height * 1.05;

				renderer.stage.interactive = false;
				renderer.stage.buttonMode = false;

				var displacementSprite = PIXI.Sprite.fromImage('/wp-content/themes/storefront-child/dist/img/cloud.png');
					displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
				var displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);

				displacementSprite.scale.set(1.5);
				displacementFilter.scale.set(0);

				renderer.stage.addChild(displacementSprite);
				renderer.stage.addChild(imageFull);
				renderer.stage.filters = [displacementFilter];
				displacementOn(renderer.stage);
			}

			function displacementOn(stage){
				stage.filters[0].scale.set(0);
				cancelAnimationFrame(raf);
				tl = new TimelineMax({paused: true});
				tl.to(stage.filters[0].scale, (easeTime / 1000), { x: 40, y: 40});
				tl.play();
				displacementAnimation(stage.children[0]);
			}
			function displacementOff(){
				tl.reverse();
			}

			function displacementAnimation(displacementElement) {
				displacementElement.x = count*5;
				displacementElement.y = count*5;
				count += 0.3;
				raf = window.requestAnimationFrame(function() {
					displacementAnimation(displacementElement);
				});
			};

	});


})(jQuery);